export enum ERROR_TYPE {
  CASHOUT_DENIED = 'CASHOUT_DENIED',
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
  DUPLICATE_USER = 'DUPLICATE_USER',
  REDIRECT_REQUIRED = 'REDIRECT_REQUIRED',
  LOCATION_REJECTED = 'LOCATION_REJECTED',
  LOCATION_INVALID = 'LOCATION_INVALID',
}

export enum ERROR_NAME {
  PRIVILEGE_ERROR = 'PrivilegeError',
}
